import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import update from "immutability-helper";
import CopyIcon from '@material-ui/icons/FileCopy';
import { withStyles } from "@material-ui/core/styles";
import { addMessage } from '../../../store/actions/message.actions';
import {
  updateRuleOrderAndExecuteRules,
  deleteAndExecuteRule,
  updateRuleActiveState
} from "../../../store/actions/rule.actions";
import AppliedRuleDetailComponent from "./appliedRuleDetail.component";
import { List, ListItem, IconButton, Icon, ListItemSecondaryAction, ListItemText, Typography } from "@material-ui/core";
import { copyRulesToClipboard } from "../../../helpers/clipboard.helper";

const styles = theme => ({
  cell: {
    padding: "0px",
    width: "100%"
  },
  white: {
    color: 'white',
  },
  content: {
    width: "200px",
    marginTop: "5px",
    minHeight: "35px",
    maxHeight: "35px"
  },
  hiddenData: {
    padding: "0px 25px 25px"
  },
  list: {
    padding: "0px",
    margin: "0px",
    listStyleType: "none"
  },
  rulesListHeader: {
    backgroundColor: theme.palette.primary.main,
    color: "white"
  },
  ruleListColor: {
    backgroundColor: 'rgb(243,243,243)',
  }
});

class AppliedRuleContainer extends React.Component {
  constructor(props) {
    super(props);

    this.moveRule = this.moveRule.bind(this);
    this.dropRule = this.dropRule.bind(this);
    this.renderRuleDetails = this.renderRuleDetails.bind(this);
    this.copyAppliedRulesToClipboard = this.copyAppliedRulesToClipboard.bind(this)

    this.state = {
      rules: _.values(this.props.rules).sort((a, b) => a.index - b.index)
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        rules: _.values(this.props.rules).sort((a, b) => a.index - b.index)
      });
    }
  }

  copyAppliedRulesToClipboard(){
    const copySucces = copyRulesToClipboard(this.state.rules);
    copySucces
    ? addMessage('success', 'Copied the rules to your clipboard!')
    : addMessage('error', 'Something went wrong copying the rules to your clipboard');
  }

  moveRule(dragIndex, hoverIndex) {
    const { rules } = this.state;
    const dragRule = rules[dragIndex];

    this.setState(
      update(this.state, {
        rules: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRule]]
        }
      })
    );
  }

  dropRule() {
    this.props.updateRuleOrderAndExecuteRules(this.state.rules);
  }

  renderRuleDetails() {
    const rules = this.state.rules.filter((rule) => {
      return rule != null;
    });

    return _.map(rules, (rule, index) => (
      <ListItem dense={true} key={index} className={this.props.classes.ruleListColor}>
        <AppliedRuleDetailComponent
          key={rule.id}
          index={index}
          rule={rule}
          moveRule={this.moveRule}
          deleteRule={this.props.deleteAndExecuteRule}
          updateRuleActive={this.props.updateRuleActiveState}
          dropRule={this.dropRule}
          rulesApplied={this.props.rulesApplied}
        />
      </ListItem>
    ));
  }

  render() {
    const { column, classes } = this.props;

    return (
      <List disabled={column.type === "Skip"}>
        <ListItem className={classes.rulesListHeader}>
          <ListItemText className={classes.white} primary={<Typography className={classes.white}>Applied rules</Typography>} />
          <ListItemSecondaryAction>
            <IconButton aria-label="Copy" disabled={column.type === 'Skip'} onClick={this.copyRulesToClipboard}>
              <CopyIcon className={classes.white} fontSize="small" />
            </IconButton>
            <IconButton float="right" onClick={this.props.toggleContainer}>
              <Icon className={classes.white} fontSize="small" >keyboard_arrow_up</Icon>
            </IconButton>

          </ListItemSecondaryAction>

        </ListItem>
        {this.renderRuleDetails()}
      </List>
    );
  }
}

AppliedRuleContainer.propTypes = {
  column: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  rules: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    attribute: PropTypes.string,
    active: PropTypes.bool
  }).isRequired,
  addMessage: PropTypes.func.isRequired,
  updateRuleOrderAndExecuteRules: PropTypes.func.isRequired,
  deleteAndExecuteRule: PropTypes.func.isRequired,
  updateRuleActiveState: PropTypes.func.isRequired,
  toggleContainer: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  rulesApplied: PropTypes.bool,
  /* eslint-enable */
};

export default connect(
  null,
  {
    addMessage,
    updateRuleOrderAndExecuteRules,
    deleteAndExecuteRule,
    updateRuleActiveState
  }
)(withStyles(styles)(AppliedRuleContainer));
